import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { Tabs, Tab } from "react-bootstrap";
import CatalogJewelryDataService from "../../../services/catalog-jewelry.service";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import catalogColorstoneService from "../../../services/catalog-colorstone.service";

const ColorStoneUploadHistory = () => {
  const { t } = useTranslation();
  const [dataUploadList, setDataUploadList] = useState([]);
  const [imageUploadList, setImageUploadList] = useState([]);
  const [colorstoneUploadList, setColorstoneUploadList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("ColorStone");
  const [dealerId, setDealerId] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [loginUser, setLoginUser] = useState({});
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [dealerMemberTypeName, setDealerMemberTypeName] = useState("");
  const [vendorStatusID, setVendorStatusID] = useState(0);
  const [stuckFileList, setStuckFileList] = useState([]);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.responseData) {
        setDealerId(loginDetials.responseData.dealerId);
        setVendorStatusID(loginDetials?.responseData?.vendorStatusID || 0);
        setDealerMemberTypeName(loginDetials.responseData.dealerMemberTypeName);
        handleGetDiamondUploadList(
          loginDetials.responseData.dealerId,
          pageNo,
          pageSize
        );
        setLoginUser(loginDetials.responseData);
      }
    }
  }, []);
  const handleTabsChange = (e) => {
    setSelectedTab(e);
    if (e === "DataUpload") {
      setPageNo(1);
      setPageSize(10);
      setTotalPage(0);
      handleGetDataUploadList(dealerId, 1, 10);
    }
    if (e === "ImageUpload") {
      setPageNo(1);
      setPageSize(10);
      setTotalPage(0);
      handleGetImageUploadList(dealerId, 1, 10);
    }
    if (e === "Diamond") {
      setPageNo(1);
      setPageSize(10);
      setTotalPage(0);
      handleGetDiamondUploadList(dealerId, 1, 10);
    }
    if (e === "StuckFile") {
      setPageNo(1);
      setPageSize(10);
      setTotalPage(0);
      handleGetStuckFileList(dealerId, 1, 10);
    }
  };
  const handleGetDataUploadList = (id, no, size) => {
    try {
      setLoading(true);
      let inputData = {
        pageIndex: no,
        pageSize: size,
        dealerId: id,
        uploadType: "ColorStone",
      };
      CatalogJewelryDataService.GetDataUploadList(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setDataUploadList(responseData[0]);
              setTotalPage(responseData[1].TotalRecords);
            } else {
              setDataUploadList([]);
              setTotalPage(0);
            }
          } else {
            setDataUploadList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetImageUploadList = (id, no, size) => {
    try {
      setLoading(true);
      let inputData = {
        pageIndex: no,
        pageSize: size,
        dealerId: id,
        uploadType: "JewelryImage",
      };
      CatalogJewelryDataService.GetImageUploadList(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setImageUploadList(responseData[0]);
              setTotalPage(responseData[1].TotalRecords);
            } else {
              setImageUploadList([]);
              setTotalPage(0);
            }
          } else {
            setImageUploadList([]);
            setTotalPage(0);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleGetDiamondUploadList = (id, no, size) => {
    try {
      setLoading(true);
      let inputData = {
        pageIndex: no,
        pageSize: size,
        dealerId: id,
        uploadType: "ColorStone",
      };
      CatalogJewelryDataService.GetDiamondUploadList(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setColorstoneUploadList(responseData[0]);
              setTotalPage(responseData[1].TotalRecords);
            } else {
              setColorstoneUploadList([]);
              setTotalPage(0);
            }
          } else {
            setColorstoneUploadList([]);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleGetStuckFileList = (id, no, size) => {
    try {
      setLoading(true);
      let inputData = {
        pageIndex: no,
        pageSize: size,
        dealerId: id.toString(),
        uploadType: "StuckFile",
      };
      catalogColorstoneService
        .GetStuckFile(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setStuckFileList(responseData[0]);
              setTotalPage(responseData[1].TotalRecords);
            } else {
              setStuckFileList([]);
              setTotalPage(0);
            }
          } else {
            setStuckFileList([]);
            setTotalPage(0);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleDownloadReport = (row, type) => {
    try {
      let inputData = {
        summaryId: row.summaryID,
        dealerId: row.dealerID,
        type: type,
      };
      setLoading(true);
      CatalogJewelryDataService.DownloadReport(inputData)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let now = new Date();
          let dateStr = String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + now.getFullYear();

          let filename =
            loginUser.dealerCompany +
            "_" +
            dateStr +
            ".csv";
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleRefershUpload = () => {
    if (selectedTab === "DataUpload") {
      handleGetDataUploadList(dealerId, pageNo, pageSize);
    }
    if (selectedTab === "ImageUpload") {
      handleGetImageUploadList(dealerId, pageNo, pageSize);
    }
    if (selectedTab === "Diamond") {
      handleGetDiamondUploadList(dealerId, pageNo, pageSize);
    }
  };
  const handlePageNoChange = (page, pageSize) => {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    setPageNo(page);
    if (selectedTab === "DataUpload") {
      handleGetDataUploadList(dealerId, page, pageSize);
    }
    if (selectedTab === "ImageUpload") {
      handleGetImageUploadList(dealerId, page, pageSize);
    }
    if (selectedTab === "Diamond") {
      handleGetDiamondUploadList(dealerId, page, pageSize);
    }
  };
  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    if (selectedTab === "DataUpload") {
      handleGetDataUploadList(dealerId, current, size);
    }
    if (selectedTab === "ImageUpload") {
      handleGetImageUploadList(dealerId, current, size);
    }
    if (selectedTab === "Diamond") {
      handleGetDiamondUploadList(dealerId, current, size);
    }
  };

  const handleDownload = (url, fileName) => {
    window.open(url, "_blank");
  };

  return (
    <div className="prodetail__section">
      {vendorStatusID == 3 ? (
        <>{t("Please Contact GemFind to get Access.")}</>
      ) : (
        <div className="form__fields">
          <div className="col-md-12">
            <div className="prod__maindiv data__maping">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="workarea__heading mt-0 mb-3">
                    {" "}
                    {t("Color Stone Upload History")}{" "}
                  </h4>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="prodesc__div">
                    <Tabs
                      id="uncontrolled-tab-example"
                      className="tab__div mb-3"
                      onSelect={(e) => {
                        handleTabsChange(e);
                      }}
                      activeKey={selectedTab}
                    >
                      {dealerMemberTypeName !== "VendorDiamond" && (
                        <Tab eventKey="DataUpload" title={t("Data Upload")}>
                          <div className="tabs__content">
                            <Table
                              columns={[
                                {
                                  title: t("Date"),
                                  dataIndex: "dateOnly",
                                  width: 100,
                                },
                                {
                                  title: t("Time"),
                                  dataIndex: "timeOnly",
                                  width: 100,
                                },
                                {
                                  title: t("File"),
                                  dataIndex: "fileName",
                                  width: 300,
                                  render: (item, row) => {
                                    return (
                                      <React.Fragment>
                                        {row.downloadLink == null ? (
                                          <span>{row.fileName}</span>
                                        ) : (
                                          <p className="linkText">
                                            <span
                                              onClick={() =>
                                                handleDownload(
                                                  row.downloadLink,
                                                  row.fileName
                                                )
                                              }
                                            >
                                              {" "}
                                              {row.fileName}
                                            </span>
                                          </p>
                                        )}
                                      </React.Fragment>
                                    );
                                  },
                                },
                                {
                                  title: t("Type"),
                                  dataIndex: "type",
                                  width: 120,
                                },
                                {
                                  title: t("Status"),
                                  dataIndex: "status",
                                  width: 100,
                                },
                                {
                                  title: t("Records"),
                                  dataIndex: "records",
                                  width: 100,
                                },
                                {
                                  title: t("Report"),
                                  dataIndex: "report",
                                  width: 100,
                                  render: (item, row) => {
                                    return (
                                      <React.Fragment>
                                        {row.status != "Completed" ? (
                                          t("InProcess")
                                        ) : (
                                          <a
                                            href="#"
                                            onClick={() => {
                                              handleDownloadReport(
                                                row,
                                                "Jewelry"
                                              );
                                            }}
                                          >
                                            {t("Download")}
                                          </a>
                                        )}
                                      </React.Fragment>
                                    );
                                  },
                                },
                              ]}
                              dataSource={dataUploadList}
                              loading={loading}
                              scroll={{ x: 600, y: 800 }}
                              pagination={{
                                current: pageNo,
                                pageSize: pageSize,
                                pageSizeOptions: [10, 20, 50, 100],
                                responsive: true,
                                showSizeChanger: true,
                                total: totalPage,
                                onChange: handlePageNoChange,
                                onShowSizeChange: handlePageSizeChange,
                              }}
                            />
                          </div>
                        </Tab>
                      )}
                      {dealerMemberTypeName !== "VendorDiamond" && (
                        <Tab eventKey="ImageUpload" title={t("Image Upload")}>
                          <Table
                            columns={[
                              {
                                title: t("Date"),
                                dataIndex: "dateOnly",
                                width: 100,
                              },
                              {
                                title: t("Time"),
                                dataIndex: "timeOnly",
                                width: 100,
                              },
                              {
                                title: t("File"),
                                dataIndex: "fileName",
                                width: 300,
                                render: (item, row) => {
                                  return (
                                    <React.Fragment>
                                      {row.downloadLink == null ? (
                                        <span>{row.fileName}</span>
                                      ) : (
                                        <p className="linkText">
                                          <span
                                            onClick={() =>
                                              handleDownload(
                                                row.downloadLink,
                                                row.fileName
                                              )
                                            }
                                          >
                                            {" "}
                                            {row.fileName}
                                          </span>
                                        </p>
                                      )}
                                    </React.Fragment>
                                  );
                                },
                              },
                              {
                                title: t("Status"),
                                dataIndex: "status",
                                width: 120,
                              },
                              {
                                title: t("Records"),
                                dataIndex: "records",
                                width: 100,
                              },
                              {
                                title: t("Report"),
                                dataIndex: "report",
                                width: 100,
                                render: (item, row) => {
                                  return (
                                    <React.Fragment>
                                      {row.status != "Completed" ? (
                                        t("InProcess")
                                      ) : (
                                        <a
                                          href="#"
                                          onClick={() => {
                                            handleDownloadReport(row, "Image");
                                          }}
                                        >
                                          {t("Download")}
                                        </a>
                                      )}
                                    </React.Fragment>
                                  );
                                },
                              },
                            ]}
                            dataSource={imageUploadList}
                            loading={loading}
                            scroll={{ x: 600, y: 800 }}
                            pagination={{
                              current: pageNo,
                              pageSize: pageSize,
                              pageSizeOptions: [10, 20, 50, 100],
                              responsive: true,
                              showSizeChanger: true,
                              total: totalPage,
                              onChange: handlePageNoChange,
                              onShowSizeChange: handlePageSizeChange,
                            }}
                          />
                        </Tab>
                      )}
                      <Tab eventKey="ColorStone" title={t("Color Stone Upload")}>
                        <Table
                          columns={[
                            {
                              title: t("Date"),
                              dataIndex: "dateOnly",
                              width: 80,
                            },
                            {
                              title: t("Time"),
                              dataIndex: "timeOnly",
                              width: 80,
                            },

                            {
                              title: t("File"),
                              dataIndex: "fileName",
                              width: 400,
                              render: (item, row) => {
                                return (
                                  <React.Fragment>
                                    {row.downloadLink == null ? (
                                      <span>{row.fileName}</span>
                                    ) : (
                                      <p className="linkText">
                                        <span
                                          onClick={() =>
                                            handleDownload(
                                              row.downloadLink,
                                              row.fileName
                                            )
                                          }
                                        >
                                          {" "}
                                          {row.fileName}
                                        </span>
                                      </p>
                                    )}
                                  </React.Fragment>
                                );
                              },
                            },
                            {
                              title: t("Type"),
                              dataIndex: "type",
                              width: 100,
                            },
                            {
                              title: t("Status"),
                              dataIndex: "status",
                              width: 80,
                            },
                            {
                              title: t("Records"),
                              dataIndex: "records",
                              width: 130,
                            },
                            {
                              title: t("Report"),
                              dataIndex: "report",
                              width: 80,
                              render: (item, row) => {
                                return (
                                  <React.Fragment>
                                    {row.status != "Completed" ? (
                                      t("InProcess")
                                    ) : (
                                      <a
                                        href="#"
                                        onClick={() => {
                                          handleDownloadReport(row, "ColorStone");
                                        }}
                                      >
                                        {t("Download")}
                                      </a>
                                    )}
                                  </React.Fragment>
                                );
                              },
                            },
                          ]}
                          dataSource={colorstoneUploadList}
                          loading={loading}
                          scroll={{ x: 600, y: 800 }}
                          pagination={{
                            current: pageNo,
                            pageSize: pageSize,
                            pageSizeOptions: [10, 20, 50, 100],
                            responsive: true,
                            showSizeChanger: true,
                            total: totalPage,
                            onChange: handlePageNoChange,
                            onShowSizeChange: handlePageSizeChange,
                          }}
                        />
                      </Tab>
                      <Tab eventKey="StuckFile" title={t("Stuck File")}>
                        <Table
                          columns={[
                            {
                              title: t("Date"),
                              dataIndex: "dateOnly",
                              width: 100,
                            },
                            {
                              title: t("Time"),
                              dataIndex: "timeOnly",
                              width: 100,
                            },
                            {
                              title: t("File Name"),
                              dataIndex: "fileName",
                              width: 300,
                            },
                            {
                              title: t("Status"),
                              dataIndex: "status",
                              width: 150,
                            },
                          ]}
                          dataSource={stuckFileList}
                          loading={loading}
                          scroll={{ x: 600, y: 800 }}
                          pagination={false}
                        />
                      </Tab>
                    </Tabs>

                    <div className="col-md-6 mt-3">
                      <button
                        className="primary-btn"
                        onClick={handleRefershUpload}
                      >
                        <i
                          className="fa fa-refresh"
                          style={{ color: "white", marginRight: "10px" }}
                        ></i>
                        {t("Update History")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorStoneUploadHistory;
